import { Capacitor } from "@capacitor/core";

export function isAndroidRuntime(platform: string, native: boolean): boolean {
  return native && platform === "android";
}

export function isAndroidApp(): boolean {
  if (isAndroidRuntime(Capacitor.getPlatform(), Capacitor.isNativePlatform())) return true;

  // A página local de contingência do Capacitor pode não receber a ponte nativa.
  // Ainda assim, ela deve abrir como Admin Android e nunca mostrar o login do site.
  return import.meta.env.PROD
    && window.location.hostname === "localhost"
    && /Android/i.test(navigator.userAgent);
}
